<script>

import {api as viewerApi} from "v-viewer"
import Timeline from 'primevue/timeline';

export default {
  inject: ['$axios', '$_'],
  name: "caseView",
  data() {
    return {
      caseData: {},
      showCase: false,
      caseError: '',
      showtab: 'profile',
      timelineEvents: [
        {date: 'Date0', status: 'Status0'},
        {date: 'Date1', status: 'Status1'},
        {date: 'Date2', status: 'Status2'}
      ],
    }
  },
  components: {Timeline},
  computed: {
    sourceImageURLs() {
      let vm = this;
      let imageURLs = {
        preopFace: [],
        preopCondition: [],
        preopIds: [],
        preopAttachments: [],
        postopFace: [],
        postopCondition: [],
        postopAttachments: []
      };

      if (vm.caseData.profileRelated !== 'false') {
        vm.$_.forEach(vm.caseData.profileRelated.faceImages, function (faceImage) {
          imageURLs.preopFace.push({
            'src': faceImage.view,
            'data-source': faceImage.view,
          });
        });
        vm.$_.forEach(vm.caseData.profileRelated.conditionImages, function (conditionImage) {
          imageURLs.preopCondition.push({
            'src': conditionImage.view,
            'data-source': conditionImage.view,
          });
        });
        vm.$_.forEach(vm.caseData.profileRelated.identificationImages, function (identificationImage) {
          imageURLs.preopIds.push({
            'src': identificationImage.view,
            'data-source': identificationImage.view,
          });
        });
        if (typeof vm.caseData.profileRelated.waiverImages !== 'undefined' && vm.caseData.profileRelated.waiverImages.length > 0) {
          imageURLs.preopAttachments.push({
            'src': vm.caseData.profileRelated.waiverImages[0].view,
            'data-source': vm.caseData.profileRelated.waiverImages[0].view,
          });
        }
        vm.$_.forEach(vm.caseData.profileRelated.additionalAttachments, function (additionalAttachment) {
          imageURLs.preopAttachments.push({
            'src': additionalAttachment.view,
            'data-source': additionalAttachment.view,
          });
        });
      }

      if (vm.caseData.feedbackRelated !== 'false') {
        vm.$_.forEach(vm.caseData.feedbackRelated.faceImages, function (faceImage) {
          imageURLs.postopFace.push({
            'src': faceImage.view,
            'data-source': faceImage.view,
          });
        });
        vm.$_.forEach(vm.caseData.feedbackRelated.conditionImages, function (conditionImage) {
          imageURLs.postopCondition.push({
            'src': conditionImage.view,
            'data-source': conditionImage.view,
          });
        });
        if (typeof vm.caseData.feedbackRelated.safeScaleReportImages !== 'undefined' && vm.caseData.feedbackRelated.safeScaleReportImages.length > 0) {
          imageURLs.postopAttachments.push({
            'src': vm.caseData.feedbackRelated.safeScaleReportImages[0].view,
            'data-source': vm.caseData.feedbackRelated.safeScaleReportImages[0].view,
          });
        }
        vm.$_.forEach(vm.caseData.feedbackRelated.additionalAttachments, function (additionalAttachment) {
          imageURLs.postopAttachments.push({
            'src': additionalAttachment.view,
            'data-source': additionalAttachment.view,
          });
        });
      }

      if (vm.caseData.comments !== 'false') {
        vm.$_.forEach(vm.caseData.comments, function (commentItem) {
        vm.$_.forEach(commentItem.commentFiles, function (commentFile) {
          if (typeof imageURLs[commentItem.key] !== 'undefined') {
            imageURLs[commentItem.key].push({
              'src': commentFile.view,
              'data-source': commentFile.view,
            });
          } else {
            imageURLs[commentItem.key] = [
              {
                'src': commentFile.view,
                'data-source': commentFile.view,
              }
            ]
          }
        });
        });
      }

      console.log(imageURLs);

      return imageURLs;
    }
  },
  methods: {
    previewURL(imageSource, initialViewIndex) {
      let vm = this;
      console.log(imageSource);
      viewerApi({
        options: {
          "inline": false,
          "button": true,
          "navbar": true,
          "title": true,
          "toolbar": true,
          "tooltip": true,
          "movable": true,
          "zoomable": true,
          "rotatable": true,
          "scalable": true,
          "transition": true,
          "fullscreen": true,
          "keyboard": true,
          "url": "data-source",
          initialViewIndex: initialViewIndex
        },
        images: vm.sourceImageURLs[imageSource]
      })
    },
  },
  mounted() {
    let vm = this;
    const storedAccount = localStorage.getItem("account");
    vm.currentData = JSON.parse(storedAccount);
    // switch (vm.$route.params.fetchCaseDetailsFrom) {
    //   case 'financecase':break;
    //   case 'opencase': break;
    //   case 'activecase': break;
    // }
    vm.fetchCaseDetails(vm.$route.params.fetchCaseDetailsFrom, vm.$route.params.caseid, vm.currentData.token, vm.$route.params.partnerId, vm.$route.params.caseYear)
        .then(function (response) {
          switch (response.data.success) {
            case 'true':
              vm.caseData = response.data.caseData;
              vm.timelineEvents = response.data.caseData.events;
              vm.showCase = true;
              break;
            case 'false':
              vm.caseError = 'An error has occurred';
              vm.showCase = false;
              break;
          }
        })
  },
}
</script>

<template>

  <div class="case-view-container landing-page-bg">

    <div class="container is-fluid is-size-4">
      Summary of case {{ $route.params.caseid }}
    </div>
    <div class="container is-fluid">
      <div class="columns is-multiline is-vcentered">
        <div class="column is-full">
          <div class="tabs is-centered">
            <ul v-if="showCase">
              <li v-bind:class="{'is-active':showtab==='profile'}" v-on:click="showtab='profile'">
                <a>Profile</a>
              </li>
              <li v-bind:class="{'is-active':showtab==='feedback'}" v-on:click="showtab='feedback'"
                  v-if="caseData.feedbackRelated!=='false'">
                <a>Feedback</a>
              </li>
              <li v-bind:class="{'is-active':showtab==='approvals'}" v-on:click="showtab='approvals'"
                  v-if="!(caseData.profileCoordinatorRating==='false' && caseData.feedbackCoordinatorRating==='false')">
                <a>Approvals</a>
              </li>
              <li v-bind:class="{'is-active':showtab==='qa'}" v-on:click="showtab='qa'"
                  v-if="caseData.finalQA!=='false'">
                <a>QA</a>
              </li>
              <li v-bind:class="{'is-active':showtab==='comments'}" v-on:click="showtab='comments'"
                  v-if="caseData.comments!=='false'">
                <a>Comments</a>
              </li>
              <li v-bind:class="{'is-active':showtab==='events'}" v-on:click="showtab='events'"
                  v-if="caseData.events!=='false'">
                <a>Events</a>
              </li>
            </ul>
            <div v-else>
              Loading...
            </div>
          </div>
        </div>
        <div class="column is-full" v-if="showtab==='profile' && showCase">
          <div class="container">
            <div class="container">
              <div class="columns is-multiline is-mobile is-vcentered">

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="personalOne" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Case Data</div>
                    </div>

                    <div
                        class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
                      <label class="label has-text-centered">Case ID:</label>
                    </div>
                    <div
                        class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
                      <label class="label has-text-left">{{ caseData.profileRelated.profileIdentifier }}</label>
                    </div>

                    <div
                        class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
                      <label class="label has-text-centered">Partner:</label>
                    </div>
                    <div
                        class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
                      <label class="label has-text-left">{{ caseData.profileRelated.partnerIdentity }}</label>
                    </div>

                    <div
                        class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
                      <label class="label has-text-centered">Case Status:</label>
                    </div>
                    <div
                        class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
                      <label class="label has-text-left">{{ caseData.caseStage }}</label>
                    </div>

                  </div>
                </div>

                <div class="column is-full">
                  <h1 class="is-size-3 is-underlined">Patient Information</h1>
                </div>

                <div class="column is-full">
                  <div id="personalOne" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Personal</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Full Name</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.patientName }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Patient Hospital Number</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.inpatientNumber }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Gender</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.patientGender }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Date of Birth</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.patientDob }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Marital Status</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.patientMarital }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Education Level</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.patientEducation }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Patient Descriptor</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.patientDescription }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Has Health Insurance</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.hasInsurance }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Phone Number of the Patient</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.patientPhoneNumber }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Government Identification</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.identificationDocument }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full" v-if="caseData.profileRelated.patientAgeGroup ==='Minor'"></div>
                <div class="column is-full" v-if="caseData.profileRelated.patientAgeGroup ==='Minor'">
                  <div id="personalTwo" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text" v-if="caseData.profileRelated.guardianIsNok==='No'">Guardian
                      </div>
                      <div class="section-box-title-text" v-if="caseData.profileRelated.guardianIsNok==='Yes'">Guardian
                        and Next of Kin
                      </div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td colspan="2">
                            <label class="label has-text-left">Guardian Name</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.guardianName }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Guardian Phone Number</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.guardianPhone }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Relationship</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.guardianRelation }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"
                     v-if="caseData.profileRelated.guardianIsNok==='No' || caseData.profileRelated.patientAgeGroup ==='Adult'"></div>
                <div class="column is-full"
                     v-if="caseData.profileRelated.guardianIsNok==='No' || caseData.profileRelated.patientAgeGroup ==='Adult'">
                  <div id="personalThree" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Next of Kin</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td colspan="2">
                            <label class="label has-text-left">Name</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.nextOfKinName }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Phone Number</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.nextOfKinPhone }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Relationship</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.nextOfKinRelation }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="personalFour" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Origin</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td colspan="2">
                            <label class="label has-text-left">Location and District of Origin</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.patientOrigin }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Nearest Health Center</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.closestHealthCenter }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Referral From</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.referralFrom }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="personalFive" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Privacy</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td colspan="2">
                            <label class="label has-text-left">Has requested for privacy</label>
                            <div class="has-text-centered" v-html="caseData.profileRelated.patientPrivacy"></div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full">
                  <h1 class="is-size-3 is-underlined">Social Economic</h1>
                </div>

                <div class="column is-full">
                  <div id="personalSix" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Employment</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Employment details of the {{
                                caseData.profileRelated.patientOrGuardian
                              }}</label>
                            <div class="has-text-centered">
                              <strong>Profile: </strong>{{ caseData.profileRelated.employmentProfile }}
                              <span v-if="caseData.profileRelated.employmentType!=='-'"><br><strong>Type: </strong>{{
                                  caseData.profileRelated.employmentType
                                }}</span>
                              <br><strong>Description: </strong>
                              <span v-if="caseData.profileRelated.employmentDescription!=='-'">
                      {{ caseData.profileRelated.employmentDescription }}
                    </span>
                              <span v-if="caseData.profileRelated.selfemploymentDescription!=='-'">
                      {{ caseData.profileRelated.selfemploymentDescription }}
                    </span>
                            </div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Monthly income of the
                              {{ caseData.profileRelated.patientOrGuardian }}
                              (USD)</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.monthlyIncome }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="personalSeven" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Housing</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Type of Housing</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.housingType }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Number of rooms</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.houseRooms }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="personalEight" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Energy</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">The main source of power (Lighting)</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.lightingEnergy }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">The main source of energy (cooking)</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.cookingEnergy }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full">
                  <h1 class="is-size-3 is-underlined">Family</h1>
                </div>

                <div class="column is-full">
                  <div id="personalNine" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Household</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Number of household members the {{
                                caseData.profileRelated.patientOrGuardian
                              }}
                              supports</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.supportingHouseHoldOf }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Number of Children the
                              {{ caseData.profileRelated.patientOrGuardian }}
                              has</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.numberOfChildren }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="column is-full"></div>
              </div>
            </div>
            <div class="container">
              <div class="columns is-multiline is-mobile is-vcentered">
                <div class="column is-full">
                  <h1 class="is-size-3 is-underlined">Illness Profile</h1>
                </div>
                <div class="column is-full">
                  <div id="illnessOne" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Surgery</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Condition</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.patientCondition }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="3">
                            <label class="label has-text-left">Length of stay with condition</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.timeWithCondition }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="2">
                            <label class="label has-text-left">Type</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.surgeryType }}</div>
                          </td>
                          <td class="middle-table-cell" colspan="2">
                            <label class="label has-text-left">Surgery required</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.surgeryRequired }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="2">
                            <label class="label has-text-left">Estimated Date of Surgery</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.estimatedSurgeryDay }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Gravidity</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.gravidity }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="3">
                            <label class="label has-text-left">Parity</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.parity }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Safe Ask</label>
                            <div class="has-text-centered safe-ask-amount">{{
                                caseData.profileRelated.safeAskAmount
                              }}
                            </div>
                          </td>
                          <td class="right-side-table-cell" colspan="3">
                            <label class="label has-text-left">Co-Payment Amount</label>
                            <div class="has-text-centered" v-html="caseData.profileRelated.coPaymentDisplay"></div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="illnessTwo" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Transport</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell">
                            <label class="label has-text-left">Time taken to reach the hospital</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.timeTakenToHospital }}</div>
                          </td>
                          <td class="middle-table-cell">
                            <label class="label has-text-left">Main mode of transport to the hospital</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.modeOfTransport }}</div>
                          </td>
                          <td class="right-side-table-cell">
                            <label class="label has-text-left">Amount spent on transport round trip</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.costOfTransport }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="illnessThree" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Patient Story</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td>
                            <div class="has-text-justified">{{ caseData.profileRelated.patientStory }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="illnessFour" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Personal Quote</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td>
                            <div class="has-text-justified">{{ caseData.profileRelated.patientQuote }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="column is-full"></div>
              </div>
            </div>
            <div class="container">
              <div class="columns is-multiline is-mobile">

                <div class="column is-full">
                  <h1 class="is-size-3 is-underlined">Patient Photo(s)</h1>
                </div>

                <div class="column is-full" v-if="caseData.profileRelated.faceImages.length">
                  <div id="AttachmentsTwo" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Pre-OP Photos</div>
                    </div>
                    <div class="column is-half input-no-padding-top"
                         v-for="(faceImage, index) in caseData.profileRelated.faceImages"
                         v-bind:key="index">
                      <div class="image-relative-container" v-on:click="previewURL('preopFace',index)">
                        <div class="image-flex-container zoom-image">
                          <img v-bind:src="`${faceImage.thumbnail}`" alt="Patient Face" class="image">
                        </div>
                      </div>
                      <div class="is-centered">Timestamp: <span>{{ faceImage.timestamp }}</span></div>
                      <div class="buttons has-addons is-centered">
                        <a class="button" v-if="faceImage.location" v-bind:href="faceImage.location"
                           target="_blank">Location</a>
                        <a v-bind:href="`${faceImage.download}?form=profile&fullname=${caseData.profileRelated.patientName}`"
                           target="_blank" class="button">Download</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full" v-if="caseData.profileRelated.conditionImages.length"></div>
                <div class="column is-full" v-if="caseData.profileRelated.conditionImages.length">
                  <div id="AttachmentsThree" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Condition</div>
                    </div>
                    <div class="column is-half input-no-padding-top"
                         v-for="(conditionImage, index) in caseData.profileRelated.conditionImages"
                         v-bind:key="index">
                      <div class="image-relative-container" v-on:click="previewURL('preopCondition',index)">
                        <div class="image-flex-container zoom-image">
                          <img v-bind:src="`${conditionImage.thumbnail}`" alt="Patient Condition"
                               class="image">
                        </div>
                        <div class="image-flex-container">Timestamp: <span>{{ conditionImage.timestamp }}</span>
                        </div>
                        <div>Location:
                          <a v-bind:href="conditionImage.location" target="_blank"
                             v-if="conditionImage.location!==''">Here</a>
                          <span v-else></span>
                        </div>
                        <a v-bind:href="`${conditionImage.download}?form=profile&fullname=${caseData.profileRelated.patientName}`"
                           target="_blank"
                           class="button is-fullwidth">Download</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full" v-if="caseData.profileRelated.identificationDocument!=='-'"></div>
                <div class="column is-full" v-if="caseData.profileRelated.identificationDocument!=='-'">
                  <div id="AttachmentsFour" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Identification Documents</div>
                    </div>
                    <div class="column is-half input-no-padding-top"
                         v-for="(identificationImage, index) in caseData.profileRelated.identificationImages"
                         v-bind:key="index">
                      <div class="image-relative-container" v-on:click="previewURL('preopIds',index)">
                        <div class="image-flex-container zoom-image">
                          <img v-bind:src="`${identificationImage.thumbnail}`"
                               alt="Identification Document"
                               class="image">
                        </div>
                        <div class="image-flex-container">Timestamp: <span>{{ identificationImage.timestamp }}</span>
                        </div>
                        <div>Location:
                          <a v-bind:href="identificationImage.location" target="_blank"
                             v-if="identificationImage.location!==''">Here</a>
                          <span v-else></span>
                        </div>
                        <a v-bind:href="`${identificationImage.download}?form=profile&fullname=${caseData.profileRelated.patientName}`"
                           target="_blank"
                           class="button is-fullwidth">Download</a>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="additionalAttachments" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Additional Attachments</div>
                    </div>
                    <div class="column is-one-quarter">
                      <div class="image-relative-container" v-on:click="previewURL('preopAttachments',0)"
                           v-if="caseData.profileRelated.waiverImages[0]">
                        <div class="image-flex-container zoom-image">
                          <img v-bind:src="`${caseData.profileRelated.waiverImages[0].thumbnail}`" alt="Waiver"
                               class="image">
                        </div>
                        <a v-bind:href="`${caseData.profileRelated.waiverImages[0].download}?form=profile&fullname=${caseData.profileRelated.patientName}`"
                           target="_blank"
                           class="button is-fullwidth">Download</a>
                      </div>
                    </div>
                    <div class="column is-one-quarter"
                         v-for="(additionalAttachment, index) in caseData.profileRelated.additionalAttachments"
                         v-bind:key="index">
                      <div class="image-relative-container" v-on:click="previewURL('preopAttachments',index+1)">
                        <div class="image-flex-container zoom-image">
                          <img v-bind:src="`${additionalAttachment.thumbnail}`"
                               alt="Additional Attachment"
                               class="image">
                        </div>
                        <a v-bind:href="`${additionalAttachment.download}?form=profile&fullname=${caseData.profileRelated.patientName}`"
                           target="_blank"
                           class="button is-fullwidth">Download</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="AttachmentsSeven" class="columns is-multiline is-mobile is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Checklist and Confirmation</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td>
                            <label class="label has-text-left">Is the proposed treatment expected to save the patient’s
                              life
                              or significantly increase their standard of living?</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.treatmentChangeLife }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label class="label has-text-left">Do you agree to provide SAFE a complete treatment update
                              within
                              30 days after the proposed treatment date listed in this form?</label>
                            <div class="has-text-centered">{{ caseData.profileRelated.treatmentUpdate }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="column is-full"></div>

              </div>
            </div>
          </div>
        </div>
        <div class="column is-full" v-if="showtab==='feedback' && showCase">
          <div class="container">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="surgeryOne" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Profile Data</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Full Name</label>
                          <div class="has-text-centered">{{ caseData.profileRelated.patientName }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="3">
                          <label class="label has-text-left">Patient Hospital Number</label>
                          <div class="has-text-centered">{{ caseData.profileRelated.inpatientNumber }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Gender</label>
                          <div class="has-text-centered">{{ caseData.profileRelated.patientGender }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="3">
                          <label class="label has-text-left">Date of Birth</label>
                          <div class="has-text-centered">{{ caseData.profileRelated.patientDob }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Type</label>
                          <div class="has-text-centered">{{ caseData.profileRelated.surgeryType }}</div>
                        </td>
                        <td class="middle-table-cell" colspan="2">
                          <label class="label has-text-left">Surgery required</label>
                          <div class="has-text-centered">{{ caseData.profileRelated.surgeryRequired }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Estimated Date of Surgery</label>
                          <div class="has-text-centered">{{ caseData.profileRelated.estimatedSurgeryDay }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <h1 class="is-size-3 is-underlined">Surgery</h1>
              </div>
              <div class="column is-full">
                <div id="surgeryData" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Surgery Data</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Status</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.surgeryStatus }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="3"
                            v-if="caseData.feedbackRelated.surgeryStatus==='Done'">
                          <label class="label has-text-left">Actual Surgery</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.actualSurgery }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="3" v-else>
                          <label class="label has-text-left">Reason</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.surgeryStatusReason }}</div>
                        </td>
                      </tr>
                      <tr v-if="caseData.feedbackRelated.surgeryStatus==='Done'">
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Admission</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.admissionData }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Surgery</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.surgeryData }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Discharge</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.dischargeData }}</div>
                        </td>
                      </tr>
                      <tr v-if="caseData.feedbackRelated.surgeryStatus==='Done'">
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Final Bill</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.finalBill }}</div>
                        </td>
                        <td class="middle-table-cell" colspan="3">
                          <label class="label has-text-left">Co-payment</label>
                          <div class="has-text-centered" v-html="caseData.feedbackRelated.coPaymentDisplay"></div>
                        </td>
                      </tr>
                      <tr v-if="caseData.feedbackRelated.surgeryStatus==='Done'">
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">SAFE-Score Rating</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.safeScoreRating }}</div>
                        </td>
                        <td class="middle-table-cell" colspan="3">
                          <label class="label has-text-left">SAFE-Score Comment</label>
                          <div class="has-text-centered" v-html="caseData.feedbackRelated.safeScoreComment"></div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container" v-if="caseData.feedbackRelated.surgeryStatus==='Done' && caseData.feedbackRelated.isBirthSurgery==='YES'">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <h1 class="is-size-3">&nbsp;</h1>
              </div>
              <div class="column is-full">
                <div id="surgeryBirth" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Birth Outcome</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Gravidity</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.birthOutcomeGravidity }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Parity</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.birthOutcomeParity }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Births</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.birthOutcomeChildrenCount }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="6">
                          <div class="columns is-multiline is-vcentered">
                            <div class="column is-full"></div>
                            <div v-for="(child, index) in caseData.feedbackRelated.childrenFormated"
                                 class="column is-half has-text-centered" v-bind:key="index"
                                 v-html="child"></div>
                            <div class="column is-full"></div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container" v-if="caseData.feedbackRelated.surgeryStatus==='Done'">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <h1 class="is-size-3">&nbsp;</h1>
              </div>
              <div class="column is-full">
                <div id="surgeryData" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Patient Story</div>
                  </div>
                  <div class="column is-full" v-html="caseData.feedbackRelated.patientStory"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="container" v-if="caseData.feedbackRelated.surgeryStatus==='Done'">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full">
                <h1 class="is-size-3">&nbsp;</h1>
              </div>
              <div class="column is-full">
                <div id="surgeryData" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Patient Quote</div>
                  </div>
                  <div class="column is-full" v-html="caseData.feedbackRelated.patientQuote"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="container" v-if="caseData.feedbackRelated.surgeryStatus==='Done'">
            <div class="columns is-multiline">

              <div class="column is-full">
                <h1 class="is-size-3 is-underlined">Patient Photo(s)</h1>
              </div>

              <div class="column is-full" v-if="caseData.feedbackRelated.faceImages.length!==0">
                <div id="AttachmentsTwo" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Post-OP Photos</div>
                  </div>
                  <div class="column is-half input-no-padding-top"
                       v-for="(faceImage, index) in caseData.feedbackRelated.faceImages"
                       v-bind:key="index">
                    <div class="image-relative-container" v-on:click="previewURL('postopFace',index)">
                      <div class="image-flex-container">
                        <img v-bind:src="`${faceImage.thumbnail}`" alt="Patient Face" class="image">
                      </div>
                      <div class="image-flex-container"><strong>Timestamp:</strong> <span>{{
                          faceImage.timestamp
                        }}</span>
                      </div>
                      <div><strong>Location:</strong>
                        <a v-bind:href="faceImage.location" target="_blank" v-if="faceImage.location!==''">Here</a>
                        <span v-else></span>
                      </div>
                      <a v-bind:href="`${faceImage.download}?form=feedback&fullname=${caseData.profileRelated.patientName}`"
                         target="_blank" class="button is-fullwidth">Download</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-full" v-if="caseData.feedbackRelated.conditionImages.length!==0"></div>
              <div class="column is-full" v-if="caseData.feedbackRelated.conditionImages.length!==0">
                <div id="AttachmentsThree" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Condition</div>
                  </div>
                  <div class="column is-half input-no-padding-top"
                       v-for="(conditionImage, index) in caseData.feedbackRelated.conditionImages"
                       v-bind:key="index">
                    <div class="image-relative-container" v-on:click="previewURL('postopCondition',index)">
                      <div class="image-flex-container">
                        <img v-bind:src="`${conditionImage.thumbnail}`" alt="Condition Image"
                             class="image">
                      </div>
                      <div class="image-flex-container"><strong>Timestamp:</strong> <span>{{
                          conditionImage.timestamp
                        }}</span></div>
                      <div><strong>Location:</strong> <a v-bind:href="conditionImage.location" target="_blank"
                                                         v-if="conditionImage.location!==''">Here</a>
                        <span v-else></span>
                      </div>
                      <a v-bind:href="`${conditionImage.download}?form=feedback&fullname=${caseData.profileRelated.patientName}`"
                         target="_blank"
                         class="button is-fullwidth">Download</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="additionalAttachments" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Additional Attachments</div>
                  </div>
                  <div class="column is-one-quarter">
                    <div class="image-relative-container" v-if="caseData.feedbackRelated.safeScaleReportImages[0]"
                         v-on:click="previewURL('postopAttachments',0)">
                      <div class="image-flex-container">
                        <img v-bind:src="`${caseData.feedbackRelated.safeScaleReportImages[0].thumbnail}`"
                             alt="Surgical Outcome Document"
                             class="image">
                      </div>
                      <a v-bind:href="`${caseData.feedbackRelated.safeScaleReportImages[0].download}?form=feedback&fullname=${caseData.profileRelated.patientName}`"
                         target="_blank"
                         class="button is-fullwidth">Download</a>
                    </div>
                  </div>
                  <div class="column is-one-quarter"
                       v-for="(additionalAttachment, index) in caseData.feedbackRelated.additionalAttachments"
                       v-bind:key="index">
                    <div class="image-relative-container" v-on:click="previewURL('postopAttachments',index+1)">
                      <div class="image-flex-container">
                        <img v-bind:src="`${additionalAttachment.thumbnail}`"
                             alt="Additional Attachment"
                             class="image">
                      </div>
                      <a v-bind:href="`${additionalAttachment.download}?form=feedback&fullname=${caseData.profileRelated.patientName}`"
                         target="_blank"
                         class="button is-fullwidth">Download</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="AttachmentsSeven" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Acknowledgement</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td>
                          <label class="label has-text-left">By submitting this form, you acknowledge that all of the
                            information contained in this document is true to the best of your knowledge. If at any
                            point the information contained above becomes inaccurate, you agree to notify the SAFE
                            Program as soon as possible.</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.signedAcknowledgement }}</div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>
            </div>
          </div>
        </div>
        <div class="column is-full" v-if="showtab==='approvals' && showCase">
          <div class="container">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="profileApproval" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Profile Approval</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Approved</label>
                          <div class="has-text-centered">{{ caseData.profileCoordinatorRating.profileApproved }}</div>
                        </td>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Approval Status</label>
                          <div class="has-text-centered">{{
                              caseData.profileCoordinatorRating.profileApprovalStatus
                            }}
                          </div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Approval Date</label>
                          <div class="has-text-centered">{{ caseData.profileCoordinatorRating.approvalDate }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Approver Type</label>
                          <div class="has-text-centered">{{ caseData.profileCoordinatorRating.approvedBy }}</div>
                        </td>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Approver Name</label>
                          <div class="has-text-centered">{{ caseData.profileCoordinatorRating.approvedByName }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Approver Email</label>
                          <div class="has-text-centered">{{ caseData.profileCoordinatorRating.approvedByEmail }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Approval Pocket</label>
                          <div class="has-text-centered">{{
                              caseData.profileCoordinatorRating.profileApprovalPocket
                            }}
                          </div>
                        </td>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Watsi ID</label>
                          <div class="has-text-centered">{{
                              caseData.profileCoordinatorRating.profileApprovalWatsiId
                            }}
                          </div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Pocket Approved</label>
                          <div class="has-text-centered">
                            {{ caseData.profileCoordinatorRating.profileApprovalFundingPocketApproved }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Data Quality Rating</label>
                          <div class="has-text-centered">{{
                              caseData.profileCoordinatorRating.profileApprovalDataQualityRating
                            }}
                          </div>
                        </td>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Data Quality Comment</label>
                          <div class="has-text-centered">
                            {{ caseData.profileCoordinatorRating.profileApprovalDataQualityComment }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Story and Quote Quality Rating</label>
                          <div class="has-text-centered">{{
                              caseData.profileCoordinatorRating.profileApprovalStoryQuoteQualityRating
                            }}
                          </div>
                        </td>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Story and Quote Quality Comment</label>
                          <div class="has-text-centered">
                            {{ caseData.profileCoordinatorRating.profileApprovalStoryQuoteQualityComment }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Image Quality Rating</label>
                          <div class="has-text-centered">{{
                              caseData.profileCoordinatorRating.profileApprovalImageQualityRating
                            }}
                          </div>
                        </td>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Image Quality Comment</label>
                          <div class="has-text-centered">
                            {{ caseData.profileCoordinatorRating.profileApprovalImageQualityComment }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Waiver Quality Rating</label>
                          <div class="has-text-centered">{{
                              caseData.profileCoordinatorRating.profileApprovalWaiverQualityRating
                            }}
                          </div>
                        </td>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Waiver Quality Comment</label>
                          <div class="has-text-centered">
                            {{ caseData.profileCoordinatorRating.profileApprovalWaiverQualityComment }}
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>
            </div>
          </div>
          <div class="container" v-if="caseData.feedbackCoordinatorRating!=='false'">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="FeedbackApproval" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Feedback Approval</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Approved</label>
                          <div class="has-text-centered">{{ caseData.feedbackCoordinatorRating.feedbackApproved }}</div>
                        </td>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Approval Status</label>
                          <div class="has-text-centered">{{
                              caseData.feedbackCoordinatorRating.feedbackApprovalStatus
                            }}
                          </div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Approval Date</label>
                          <div class="has-text-centered">{{ caseData.feedbackCoordinatorRating.approvalDate }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Approver Type</label>
                          <div class="has-text-centered">{{ caseData.feedbackCoordinatorRating.approvedBy }}</div>
                        </td>
                        <td class="left-side-table-cell" colspan="2">
                          <label class="label has-text-left">Approver Name</label>
                          <div class="has-text-centered">{{ caseData.feedbackCoordinatorRating.approvedByName }}</div>
                        </td>
                        <td class="right-side-table-cell" colspan="2">
                          <label class="label has-text-left">Approver Email</label>
                          <div class="has-text-centered">{{ caseData.feedbackCoordinatorRating.approvedByEmail }}</div>
                        </td>
                      </tr>
                      <tr v-if="caseData.feedbackCoordinatorRating.feedbackApprovalsurgeryperformed!=='-'">
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Surgery Performed</label>
                          <div class="has-text-centered">{{
                              caseData.feedbackCoordinatorRating.feedbackApprovalsurgeryperformed
                            }}
                          </div>
                        </td>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Safe Ask</label>
                          <div class="has-text-centered">
                            {{ caseData.feedbackCoordinatorRating.feedbackApprovalsafeaskamount }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Surgery Accuracy Rating</label>
                          <div class="has-text-centered">{{
                              caseData.feedbackCoordinatorRating.feedbackApprovalSurgeryAccuracyRating
                            }}
                          </div>
                        </td>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Surgery Accuracy Comment</label>
                          <div class="has-text-centered">
                            {{ caseData.feedbackCoordinatorRating.feedbackApprovalSurgeryAccuracyComment }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Story and Quote Quality Rating</label>
                          <div class="has-text-centered">{{
                              caseData.feedbackCoordinatorRating.feedbackApprovalStoryQuoteQualityRating
                            }}
                          </div>
                        </td>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Story and Quote Quality Comment</label>
                          <div class="has-text-centered">
                            {{ caseData.feedbackCoordinatorRating.feedbackApprovalStoryQuoteQualityComment }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Image Quality Rating</label>
                          <div class="has-text-centered">{{
                              caseData.feedbackCoordinatorRating.feedbackApprovalImageQualityRating
                            }}
                          </div>
                        </td>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Image Quality Comment</label>
                          <div class="has-text-centered">
                            {{ caseData.feedbackCoordinatorRating.feedbackApprovalImageQualityComment }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Safe Score Accuracy Rating</label>
                          <div class="has-text-centered">{{
                              caseData.feedbackCoordinatorRating.feedbackApprovalSafeScoreAccuracyRating
                            }}
                          </div>
                        </td>
                        <td class="left-side-table-cell" colspan="3">
                          <label class="label has-text-left">Safe Score Accuracy Comment</label>
                          <div class="has-text-centered">
                            {{ caseData.feedbackCoordinatorRating.feedbackApprovalSafeScoreAccuracyComment }}
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>
            </div>
          </div>
        </div>
        <div class="column is-full" v-if="showtab==='qa' && showCase">
          <div class="container">
            <div class="columns is-multiline is-mobile is-vcentered">
              <div class="column is-full"></div>
              <div class="column is-full">
                <div id="surgeryOne" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Surgery QA</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Surgery Required</label>
                          <div class="has-text-centered">
                            <strong>Type:</strong> {{ caseData.profileRelated.surgeryType }}
                            <br>
                            <strong>Surgery:</strong> {{ caseData.profileRelated.surgeryRequired }}
                          </div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Surgery Performed</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.actualSurgery }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Surgery Expected Date</label>
                          <div class="has-text-centered">{{ caseData.profileRelated.estimatedSurgeryDay }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Surgery Actual Date</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.surgeryData }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <div class="box has-text-left">
                            <span v-html="caseData.finalQA.surgeryDateQA"></span>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>

              <div class="column is-full">
                <div id="surgeryOne" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Dates QA</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Profile Creation</label>
                          <div class="has-text-centered">{{ caseData.profileRelated.profileCreationDate }}</div>
                        </td>
                        <td class="middle-table-cell">
                          <label class="label has-text-left">Profile Submission</label>
                          <div class="has-text-centered">{{ caseData.profileRelated.profileSubmissionDate }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Profile Approval</label>
                          <div class="has-text-centered">{{ caseData.profileRelated.approved_at }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Surgery Date</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.surgeryData }}</div>
                        </td>
                        <td class="middle-table-cell">
                          <label class="label has-text-left">Feedback Creation</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.created_at }}</div>
                        </td>
                        <td class="right-side-table-cell">
                          <label class="label has-text-left">Feedback Submission</label>
                          <div class="has-text-centered">{{ caseData.feedbackRelated.submitted_at }}</div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <div class="box has-text-left">
                            <span v-html="caseData.finalQA.profileSubmission" v-if="caseData.finalQA.profileSubmission.length>0"></span><br v-if="caseData.finalQA.profileSubmission.length>0">
                            <span v-html="caseData.finalQA.profileSurgery" v-if="caseData.finalQA.profileSurgery.length>0"></span><br v-if="caseData.finalQA.profileSurgery.length>0">
                            <span v-html="caseData.finalQA.profileApproval" v-if="caseData.finalQA.profileApproval.length>0"></span><br v-if="caseData.finalQA.profileApproval.length>0">
                            <span v-html="caseData.finalQA.profileApprovalSurgery" v-if="caseData.finalQA.profileApprovalSurgery.length>0"></span><br v-if="caseData.finalQA.profileApprovalSurgery.length>0">
                            <span v-html="caseData.finalQA.feedbackCreation" v-if="caseData.finalQA.feedbackCreation.length>0"></span><br v-if="caseData.finalQA.feedbackCreation.length>0">
                            <span v-html="caseData.finalQA.feedbackSubmission" v-if="caseData.finalQA.feedbackSubmission.length>0"></span><br v-if="caseData.finalQA.feedbackSubmission.length>0">
                            <span v-html="caseData.finalQA.feedbackSurgery" v-if="caseData.finalQA.feedbackSurgery.length>0"></span><br v-if="caseData.finalQA.feedbackSurgery.length>0">
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>

              <div class="column is-full">
                <div id="surgeryOne" class="columns is-multiline is-vcentered section-box">
                  <div class="column is-full section-box-title-column">
                    <div class="section-box-title-text">Images QA</div>
                  </div>
                  <div class="column is-full can-scroll-content">
                    <table class="table is-striped is-fullwidth">
                      <tbody>
                      <tr>
                        <td class="left-side-table-cell">
                          <label class="label has-text-left">Pre-Op Photos</label>
                          <div class="has-text-centered">
                            <div class="columns is-multiline is-vcentered"
                                 v-for="(faceImage, index) in caseData.profileRelated.faceImages"
                                 v-bind:key="index">
                              <div class="column is-half input-no-padding-top">
                                <div class="image-relative-container" v-on:click="previewURL('preopFace',index)">
                                  <div class="image-flex-container">
                                    <figure class="image is-200x200">
                                      <img v-bind:src="`${faceImage.thumbnail}`" alt="Patient Face" class="image">
                                    </figure>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-half input-no-padding-top">
                                <div class=""><strong>Timestamp:</strong><br>
                                  <span>{{ faceImage.timestamp }}</span>
                                </div>
                                <div><strong>Location:</strong><br>
                                  <a v-bind:href="faceImage.location" target="_blank"
                                     v-if="faceImage.location!==''">Here</a>
                                  <span v-else></span>
                                </div>
                                <div class="box has-text-left">
                                  <span v-html="caseData.finalQA.profileFacesQA[index].profileSubmission"></span><br>
                                  <span v-html="caseData.finalQA.profileFacesQA[index].surgeryDone"></span><br>
                                </div>
                              </div>
                            </div>
                            <div class="columns is-multiline is-vcentered"
                                 v-for="(conditionImage, index) in caseData.profileRelated.conditionImages"
                                 v-bind:key="index">
                              <div class="column is-half input-no-padding-top">
                                <div class="image-relative-container" v-on:click="previewURL('preopCondition',index)">
                                  <div class="image-flex-container">
                                    <figure class="image is-200x200">
                                      <img v-bind:src="`${conditionImage.thumbnail}`" alt="Patient Face" class="image">
                                    </figure>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-half input-no-padding-top">
                                <div class=""><strong>Timestamp:</strong><br>
                                  <span>{{ conditionImage.timestamp }}</span>
                                </div>
                                <div><strong>Location:</strong><br>
                                  <a v-bind:href="conditionImage.location" target="_blank"
                                     v-if="conditionImage.location!==''">Here</a>
                                  <span v-else></span>
                                </div>
                                <div class="box has-text-left">
                                  <span
                                      v-html="caseData.finalQA.profileConditionsQA[index].feedbackSubmission"></span><br>
                                  <span v-html="caseData.finalQA.profileConditionsQA[index].surgeryDone"></span><br>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="right-side-table-cell" v-if="caseData.feedbackRelated.surgeryStatus==='Done'">
                          <label class="label has-text-left">Post-Op Photos</label>
                          <div class="has-text-centered">
                            <div class="columns is-multiline is-vcentered"
                                 v-for="(faceImage, index) in caseData.feedbackRelated.faceImages"
                                 v-bind:key="index">
                              <div class="column is-half input-no-padding-top">
                                <div class="image-relative-container" v-on:click="previewURL('postopFace',index)">
                                  <div class="image-flex-container">
                                    <figure class="image is-200x200">
                                      <img v-bind:src="`${faceImage.thumbnail}`" alt="Patient Face" class="image">
                                    </figure>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-half input-no-padding-top">
                                <div class=""><strong>Timestamp:</strong><br>
                                  <span>{{ faceImage.timestamp }}</span>
                                </div>
                                <div><strong>Location:</strong><br>
                                  <a v-bind:href="faceImage.location" target="_blank"
                                     v-if="faceImage.location!==''">Here</a>
                                  <span v-else></span>
                                </div>
                                <div class="box has-text-left">
                                  <span v-html="caseData.finalQA.feedbackFacesQA[index].feedbackSubmission"></span><br>
                                  <span v-html="caseData.finalQA.feedbackFacesQA[index].surgeryDone"></span><br>
                                </div>
                              </div>
                            </div>
                            <div class="columns is-multiline is-vcentered"
                                 v-for="(conditionImage, index) in caseData.feedbackRelated.conditionImages"
                                 v-bind:key="index">
                              <div class="column is-half input-no-padding-top">
                                <div class="image-relative-container" v-on:click="previewURL('postopCondition',index)">
                                  <div class="image-flex-container">
                                    <figure class="image is-200x200">
                                      <img v-bind:src="`${conditionImage.thumbnail}`" alt="Patient Face" class="image">
                                    </figure>
                                  </div>
                                </div>
                              </div>
                              <div class="column is-half input-no-padding-top">
                                <div class=""><strong>Timestamp:</strong><br>
                                  <span>{{ conditionImage.timestamp }}</span>
                                </div>
                                <div><strong>Location:</strong><br>
                                  <a v-bind:href="conditionImage.location" target="_blank"
                                     v-if="conditionImage.location!==''">Here</a>
                                  <span v-else></span>
                                </div>
                                <div class="box has-text-left">
                                  <span v-html="caseData.finalQA.feedbackConditionsQA[index].feedbackSubmission"></span><br>
                                  <span v-html="caseData.finalQA.feedbackConditionsQA[index].surgeryDone"></span><br>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="column is-full"></div>
            </div>
          </div>
        </div>
        <div class="column is-full" v-if="showtab==='comments' && showCase">
          <div class="container">
            <div class="columns is-multiline is-mobile is-vcentered">
              <div class="column is-full" v-for="(commentData, commentIndex) in caseData.comments"
                   v-bind:key="commentIndex">
                <article class="message" v-bind:class="commentData.articleColor">
                  <div class="message-body">
                    <p class="comment-text">{{ commentData.text }}</p>
                    <div v-if="commentData.commentFiles.length>0" class="columns is-multiline is-mobile is-vcentered">
                      <div class="column is-one-quarter"
                           v-for="(attachmentData, AttachmentIndex) in commentData.commentFiles"
                           v-bind:key="AttachmentIndex">
                        <div class="image-relative-container" v-on:click="previewURL(commentData.key,AttachmentIndex)">
                          <img v-bind:src="attachmentData.thumbnail" alt="Attachment"/>
                        </div><br>
                        <a v-bind:href="`${attachmentData.download}?form=caseview&fullname=${caseData.profileRelated.patientName}`"
                           target="_blank"
                           class="button">Download</a>
                      </div>
                    </div>
                    <p class="comment-poster">Posted by {{ commentData.poster }} on {{ commentData.dateTime }}</p>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-full white-bg-container" v-if="showtab==='events' && showCase">
          <div class="container">
            <div class="columns is-multiline is-mobile is-vcentered">
              <div class="column is-full">
                <Timeline :value="timelineEvents">
                  <template #marker="slotProps">
                    <span
                        class="flex w-8 h-8 items-center justify-center text-white rounded-full z-10 shadow-sm rounded-marker"
                        :style="{ backgroundColor: slotProps.item.markerColor }">
                       <font-awesome-icon :icon="['fas', slotProps.item.icon ]"
                                          :style="{ color: slotProps.item.iconColor }"/>
                    </span>
                  </template>
                  <template #opposite="slotProps">
                    <small class="text-surface-500 dark:text-surface-400">{{ slotProps.item.date }}</small>
                  </template>
                  <template #content="slotProps">
                    {{ slotProps.item.status }}
                  </template>
                </Timeline>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>

.landing-page-bg {
  background: linear-gradient(135deg, #c2e8ff 0%, #ffeebf 100%);
}

.case-view-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  padding: 5px;
  margin: 0;
  overflow: scroll;
}

.white-bg-container {
  background-color: white !important;
}

.rounded-marker {
  height: 25px !important;
  width: 25px !important;
  background-color: #dedede !important;
  border-radius: 50% !important;
}

.comment-text {
  text-align: justify;
}

.comment-poster {
  text-align: right;
  position: relative;
  bottom: -20px;
}
</style>